<template>
  <div>
    <v-card class="mb-8">
      <v-alert
        v-model="isAlertVisible"
        :color="error ? 'error' : 'success'"
        dismissible
        text
        transition="slide-y-transition"
      >
        {{ message }}
      </v-alert>
      <div class="m-2">
        <v-row class="ml-5 mr-5">
          <v-col
            cols="12"
            md="4"
          >
            <v-text-field
              v-model="field.keyword"
              label="Filtrer par mot clé"
              outlined
              dense
              placeholder="Filtrer par mot clé"
              hide-details="auto"
              :rules="rules.keyword"
              clearable
              @input="filterItems"
            ></v-text-field>
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <v-select
              v-model="field.is_active"
              :items="answers"
              label="ACTIF?"
              outlined
              dense
              placeholder="ACTIF?"
              clearable
              hide-details="auto"
              persistent-hint
              single-line
              :rules="rules.is_active"
              @input="getApisByFields"
            ></v-select>
          </v-col>
          <v-col
            cols="12"
            md="4"
          >
            <v-select
              v-model="field.is_sandbox"
              :items="answers_sandbox"
              label="SANDBOX?"
              outlined
              dense
              placeholder="SANDBOX?"
              clearable
              hide-details="auto"
              persistent-hint
              single-line
              :rules="rules.is_sandbox"
              @input="getApisByFields"
            ></v-select>
          </v-col>
        </v-row>
      </div>
    </v-card>
    <v-card>
      <v-data-table
        :loading="isDialogVisible"
        loading-text="Chargement..."
        :headers="headers"
        :items="apis"
        :items-per-page="itemsPerPage"
        :page.sync="currentPage"
        dense
        fixed-header
        height="500"
        hide-default-footer
        @page-count="currentPage = $event"
      >
        <template #[`item.is_active`]="{item}">
          <v-chip
            small
            :color="item.is_active ? 'primary' : 'error'"
            :class="`${item.is_active ? 'primary' : 'error'}--text`"
            class="v-chip-light-bg"
          >
            {{ item.is_active === true ? 'OUI' : 'NON' }}
          </v-chip>
        </template>
        <template #[`item.is_sandbox`]="{item}">
          <v-chip
            small
            :color="item.is_sandbox ? 'primary' : 'error'"
            :class="`${item.is_sandbox ? 'primary' : 'error'}--text`"
            class="v-chip-light-bg"
          >
            {{ item.is_sandbox === true ? 'OUI' : 'NON' }}
          </v-chip>
        </template>

        <template #[`item.created_at`]="{item}">
          {{ formattingDate(`${item.created_at}`) }}
        </template>

        <!-- action -->
        <template #[`item.actions`]="{ item }">
          <buttons-group
            :item="item"
            :edit="true"
            :remove="false"
            :view="false"
            :lock="false"
            :status="false"
            @edit="openForm(item)"
          />
        </template>
      </v-data-table>

      <v-card-text class="pt-2">
        <v-row>
          <v-col
            lg="2"
            cols="3"
          >
            <v-text-field
              :value="field.paginate"
              label="Lignes par page:"
              type="number"
              min="-1"
              max="15"
              hide-details
              @input="getApisPerPage"
            ></v-text-field>
          </v-col>

          <v-col
            lg="10"
            cols="9"
            class="d-flex justify-end"
          >
            <v-pagination
              v-model="currentPage"
              total-visible="6"
              :length="lastPage"
              @input="getApis"
            ></v-pagination>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <api-form-dialog
      :api="apiForm"
      :dialog="dialog"
      @clickout="closeDialog"
      @submitted="loading"
    />
  </div>
</template>

<script>
import LoaderDialog from '@core/components/dialogs/LoaderDialog'
import { mapGetters, mapState } from 'vuex'
import { ref } from '@vue/composition-api/dist/vue-composition-api'
import {
  mdiAccountLock, mdiCashMinus, mdiCashPlus,
  mdiDeleteOutline,
  mdiDotsVertical, mdiEyeOutline, mdiLockOpen,
  mdiPencilOutline, mdiRefresh,
  mdiSquareEditOutline, mdiKeyVariant,
} from '@mdi/js'
import { formatDate } from '@core/date/dateFunctions'
import ApiFormDialog from '@core/components/operator/ApiFormDialog'
import ButtonsGroup from '@core/components/buttons/ButtonsGroup'
import store from '@/store'

export default {
  name: 'OperatorApiList',

  components: { ButtonsGroup, ApiFormDialog, LoaderDialog },

  data() {
    return {
      currentPage: null,
      lastPage: null,
      dialog: false,
      keyDialog: false,
      dialogDelete: false,
      isDialogVisible: false,
      message: null,
      error: false,
      isAlertVisible: false,
      rules: {
        keyword: [true],
        is_sandbox: [true],
        is_active: [true],
      },
      apiForm: {
        id: null,
        name: null,
        code: null,
        min_amount: null,
        max_amount: null,
        key: null,
        callback: null,
        is_sandbox: null,
        is_active: null,
      },
    }
  },
  computed: {
    ...mapGetters('api', ['apis', 'current_page', 'last_page', 'per_page']),
    ...mapState('operator', ['operator']),
    ...mapState('api', ['field']),
  },

  mounted() {
    this.getApis(this.current_page ? this.current_page : null)
  },

  methods: {
    loading() {
      this.isDialogVisible = !this.isDialogVisible
    },

    closeDialog() {
      this.dialog = false
    },

    closeKeyDialog() {
      this.keyDialog = false
    },

    formattingDate(date) {
      return formatDate(date)
    },

    deleteItemConfirm() {
      this.closeDelete()
    },

    openItem(item) {
      this.$router.push({ name: 'showpayment', params: { id: item.id } })
    },

    openForm(item) {
      this.apiForm = item
      this.dialog = true
    },

    closeDelete() {
      this.dialogDelete = false
    },

    getApis(page = 1) {
      setTimeout(() => {
        this.isDialogVisible = true
        store.dispatch('api/getApisList', { page, field: this.field }).then(() => {
          this.currentPage = this.current_page
          this.lastPage = this.last_page
          this.isDialogVisible = false
          this.isAlertVisible = false
          Object.keys(this.rules).forEach(key => {
            this.rules[key] = [true]
          })
        }).catch(error => {
          this.message = error.response.data.message
          if (error.response.data.errors !== undefined) {
            this.rules.keyword = error.response.data.errors.keyword !== undefined ? error.response.data.errors.keyword : [true]
            this.rules.is_sandbox = error.response.data.errors.is_sandbox !== undefined ? error.response.data.errors.is_sandbox : [true]
            this.rules.is_active = error.response.data.errors.is_active !== undefined ? error.response.data.errors.is_active : [true]
          }
          this.error = true
          this.isAlertVisible = true
          this.isDialogVisible = false
        })
      }, 500)
    },

    // eslint-disable-next-line camelcase
    getApisPerPage(per_page) {
      // eslint-disable-next-line camelcase
      this.field.operator_id = this.operator.id
      if (per_page !== null) {
        this.isDialogVisible = true
        // eslint-disable-next-line camelcase
        this.field.paginate = per_page
        this.itemsPerPage = parseInt(per_page, 10)
        store.dispatch('api/getApisList', {
          page: this.currentPage,
          field: this.field,
        }).then(() => {
          this.currentPage = this.current_page
          this.lastPage = this.last_page
          this.isDialogVisible = false
          this.isAlertVisible = false
          Object.keys(this.rules).forEach(key => {
            this.rules[key] = [true]
          })
        })
      }
    },

    filterItems() {
      setTimeout(() => {
        this.getApisByFields()
      }, 1500)
    },

    getApisByFields() {
      this.isDialogVisible = true
      this.field.operator_id = this.operator.id
      store.dispatch('api/getApisList', {
        page: this.currentPage,
        field: this.field,
      }).then(() => {
        this.currentPage = this.current_page
        this.lastPage = this.last_page
        this.isDialogVisible = false
        this.isAlertVisible = false
        this.error = false
        this.isAlertVisible = false
        Object.keys(this.rules).forEach(key => {
          this.rules[key] = [true]
        })
      }).catch(error => {
        this.message = error.response.data.message
        if (error.response.data.errors !== undefined) {
          this.rules.keyword = error.response.data.errors.keyword !== undefined ? error.response.data.errors.keyword : [true]
          this.rules.is_sandbox = error.response.data.errors.is_sandbox !== undefined ? error.response.data.errors.is_sandbox : [true]
          this.rules.is_active = error.response.data.errors.is_active !== undefined ? error.response.data.errors.is_active : [true]
        }
        this.error = true
        this.isAlertVisible = true
      })
    },
  },

  setup() {
    const date = ref(null)
    const menu = ref(false)
    const picker = ref(null)
    const menuref = ref(null)

    const save = d => {
      menuref.value.save(d)
    }

    return {
      save,
      date,
      menu,
      picker,
      menuref,
      headers: [
        { text: 'NOM', value: 'name' },
        { text: 'MONTANT MINIMAL (FCFA)', value: 'min_amount' },
        { text: 'MONTANT MAXIMAL (FCFA)', value: 'max_amount' },
        { text: 'CALLBACK', value: 'callback' },
        { text: 'SANDBOX?', value: 'is_sandbox' },
        { text: 'ACTIF?', value: 'is_active' },
        { text: 'DATE DE CREATION', value: 'created_at' },
        { text: 'ACTIONS', value: 'actions' },
      ],
      itemsPerPage: parseInt(store.state.api.field.paginate, 10),

      // icons
      icons: {
        mdiSquareEditOutline,
        mdiDotsVertical,
        mdiDeleteOutline,
        mdiPencilOutline,
        mdiAccountLock,
        mdiLockOpen,
        mdiEyeOutline,
        mdiRefresh,
        mdiCashMinus,
        mdiCashPlus,
        mdiKeyVariant,
      },
      answers: [
        { text: '--ACTIF?--', value: null },
        { text: 'OUI', value: true },
        { text: 'NON', value: false },
      ],
      answers_sandbox: [
        { text: '--SANDBOX?--', value: null },
        { text: 'OUI', value: true },
        { text: 'NON', value: false },
      ],
    }
  },
}
</script>

<style scoped>

</style>
